import script from "./XtsProductOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./XtsProductOverview.vue?vue&type=script&setup=true&lang=js"

import "./XtsProductOverview.vue?vue&type=style&index=0&id=b64ef212&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b64ef212"]])

export default __exports__